<template>
  <div class="custom-select">
    <el-input
      v-model="keyword"
      placeholder="请输入搜索内容"
      clearable
      @input="handleInput"
      @focus="handleFocus"
      :loading="loading"
      :style="{ width: '100%' }"
    />

    <el-dropdown v-if="showDropdown && formattedOptions.length > 0" trigger="click">
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="item in formattedOptions"
          :key="item.value"
          @click.native="selectItem(item)"
        >
          {{ item.label }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'CustomSelect',
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    remoteMethod: {
      type: Function,
      required: true,
    }
  },
  setup(props) {
    const keyword = ref('')
    const showDropdown = ref(false)

    const handleInput = (val) => {
      if (val && val.length > 0) {
        // 如果输入框有内容，则尝试显示下拉
        showDropdown.value = true
        props.remoteMethod(val)
      } else {
        // 输入框为空，隐藏下拉
        showDropdown.value = false
      }
    }

    const handleFocus = () => {
      if (!keyword.value) {
        showDropdown.value = false
      }
    }

    const selectItem = (item) => {
      keyword.value = item.label
      showDropdown.value = false
    }
    const formattedOptions = computed(() => {
      return props.options.map(item => {
          return { label: item, value: item }
      })
    })
    return {
      keyword,
      showDropdown,
      handleInput,
      handleFocus,
      formattedOptions,
      selectItem
    }
  }
})
</script>

<style scoped>
.custom-select {
  position: relative;
}
.el-dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
  width: 100%;
}
</style>
